const state = {
    accessList: {
        admin: ["home", "elecboard", "machstatus", "activation", "operatelog", "errorhistory", "workorderhistory", "ordermanagement", "operation", "heattreatmentinstant", "statisticstable"],
        manager: ["home", "elecboard", "machstatus", "activation", "operatelog", "errorhistory", "workorderhistory", "heattreatmentinstant", "statisticstable"],
        general: ["home", "elecboard", "machstatus", "activation", "operatelog", "errorhistory", "workorderhistory", "heattreatmentinstant"],
        PC: ["home", "elecboard", "machstatus", "activation", "operatelog", "errorhistory", "workorderhistory", "ordermanagement", "heattreatmentinstant"],
    },
};
const getters = {
    get_accessList: (state) => {
        return state.accessList;
    },
};

export default {
    namespaced: true,
    state,
    getters,
};


// WEBPACK FOOTER //
// ./src/store/modules/accessList.js